<div class="toolbar-container">
  <div class="toolbar">
    <div class="title-container">
      <h2 [textContent]="text.title"></h2>
    </div>
  </div>
</div>
